module.exports = __webpack_public_path__ + "static/img/business_automation.c3c7c57.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/business_automation.jpg
// module id = TJff
// module chunks = 1